// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3jn9C","label":"Radio_label__3i7cB","checkMark":"Radio_checkMark__NJuU2","disabled":"Radio_disabled__1rhe7"};